'use client';

import React from 'react';
import GuideCard from '@/components/packages/GuideCard';
import { GuideDetails } from '@/types/activityDetailsTypes';
import Border from '../../common/border';

interface ExperienceGuideProps {
  experience: unknown;
}

export const ExperienceGuide: React.FC<ExperienceGuideProps> = ({
  experience,
}) => {
  if (!experience) return null;

  const getGuideDetails = (): GuideDetails | null => {
    const exp = experience as {
      guide?: unknown;
      guideDetails?: GuideDetails;
    };

    // Check if guideDetails exists (from enriched data)
    if (exp?.guideDetails) {
      return exp.guideDetails;
    }

    // Otherwise, try to extract from guide object
    if (exp?.guide && typeof exp.guide === 'object' && exp.guide !== null) {
      const guide = exp.guide as {
        _id?: string;
        userId?: string;
        name?: string;
        contactEmail?: string;
        contactPhone?: number;
        companyName?: string | null;
        address?: string | null;
        type?: string | string[] | null;
        profileDescription?: string | null;
        languages?: string[] | null;
        imageUrl?: string | null;
        nexgoVerified?: boolean | null;
        rating?: number | null;
        guideIntroVideoUrl?: string | null;
      };

      if (guide._id || guide.name) {
        return {
          _id: guide._id || '',
          userId: guide.userId || '',
          name: guide.name || '',
          contactEmail: guide.contactEmail || '',
          contactPhone: guide.contactPhone || 0,
          address: guide.address || '',
          type: Array.isArray(guide.type)
            ? guide.type
            : guide.type
              ? [guide.type]
              : [],
          profileDescription: guide.profileDescription || '',
          languages: guide.languages || [],
          imageUrl: guide.imageUrl || '',
          nexgoVerified: guide.nexgoVerified || false,
          rating: guide.rating || 0,
          guideIntroVideoUrl: guide.guideIntroVideoUrl || '',
        };
      }
    }

    return null;
  };

  const guideDetails = getGuideDetails();

  if (!guideDetails) return null;

  return (
    <div className='space-y-4'>
      <GuideCard guidedetails={guideDetails} />
      <div className='pt-4'>
        <Border />
      </div>
    </div>
  );
};
